<template>
  <section>
    <h3
      class="text-black text-center text-3xl lg:text-4xl xl:text-5xl font-extrabold mb-4 mt-12"
    >
      <span class="text-primar-400">Explore</span> Our Tradeable Assets
    </h3>
    <h4
      class="mb-6 text-black text-xl leading-7 font-normal text-center"
    >
      Discover which assets are hot on our platform and take the chance to dive in with industry breaking low fees
    </h4>
    <nav
      class="
        scrollbar-none
        overflow-x-auto
        flex
        items-center
        space-x-1
        mb-3
        whitespace-nowrap
      "
    >
      <a
        @click.prevent="view = 'forex'"
        href="#"
        :class="
          view == 'forex'
            ? 'bg-orange-450 text-white'
            : 'bg-gray-100 text-gray-400'
        "
        class="
          rounded-tl-md
          flex-1
          p-2
          md:p-4
          text-center
          font-light
          hover:bg-orange-400 hover:text-white
        "
      >
        Forex
      </a>
      <a
        @click.prevent="view = 'crypto'"
        href="#"
        :class="
          view == 'crypto'
            ? 'bg-orange-450 text-white'
            : 'bg-gray-100 text-gray-400'
        "
        class="
          flex-1
          p-2
          md:p-4
          text-center
          font-light
          hover:bg-orange-400 hover:text-white
        "
      >
        Crypto
      </a>
      <a
        @click.prevent="view = 'indices'"
        href="#"
        :class="
          view == 'indices'
            ? 'bg-orange-450 text-white'
            : 'bg-gray-100 text-gray-400'
        "
        class="
          flex-1
          p-2
          md:p-4
          text-center
          font-light
          hover:bg-orange-400 hover:text-white
        "
      >
        Indices
      </a>
      <a
        @click.prevent="view = 'futures'"
        href="#"
        :class="
          view == 'futures'
            ? 'bg-orange-450 text-white'
            : 'bg-gray-100 text-gray-400'
        "
        class="
          flex-1
          p-2
          md:p-4
          text-center
          font-light
          hover:bg-orange-400 hover:text-white
        "
      >
        Futures
      </a>
    </nav>
    <div class="md:flex overflow-x-auto" v-if="view == 'forex'">
      <div class="">
        <div class="tradingview-widget-container">
          <div class="tradingview-widget-container__widget"></div>
          <script
            type="application/javascript"
            src="https://s3.tradingview.com/external-embedding/embed-widget-market-quotes.js"
            async
          >
            {
            "width": 750,
            "height": 450,
            "symbolsGroups": [
                {
                "name": "Forex",
                "originalName": "Forex",
                "symbols": [
                    {
                    "name": "FX:EURUSD"
                    },
                    {
                    "name": "FX:EURCHF"
                    },
                    {
                    "name": "FX:EURJPY"
                    },
                    {
                    "name": "FX:EURGBP"
                    },
                    {
                    "name": "FX:USDCAD"
                    }
                ]
                }
            ],
            "showSymbolLogo": true,
            "colorTheme": "light",
            "isTransparent": false,
            "locale": "en"
            }
          </script>
        </div>
      </div>
    </div>
    <div class="md:flex  overflow-x-auto" v-if="view == 'crypto'">
      <div >
        <div class="tradingview-widget-container">
          <div class="tradingview-widget-container__widget"></div>
          <script
            type="application/javascript"
            src="https://s3.tradingview.com/external-embedding/embed-widget-market-quotes.js"
            async
          >
            {
            "width": 750,
            "height": 450,
            "symbolsGroups": [
                {
                "name": "Crypto",
                "originalName": "Crypto",
                "symbols": [
                    {
                    "name": "BITSTAMP:BTCUSD"
                    },
                    {
                    "name": "COINBASE:BTCEUR"
                    },
                    {
                    "name": "BINANCE:ETHBTC"
                    },
                    {
                    "name": "BINANCE:ETHUSD"
                    },
                    {
                    "name": "BINANCE:ETHEUR"
                    }
                ]
                }
            ],
            "showSymbolLogo": true,
            "colorTheme": "light",
            "isTransparent": false,
            "locale": "en"
            }
          </script>
        </div>
      </div>
    </div>
    <div class="md:flex  overflow-x-auto" v-if="view == 'indices'">
      <div>
        <div class="tradingview-widget-container">
          <div class="tradingview-widget-container__widget"></div>
          <script
            type="application/javascript"
            src="https://s3.tradingview.com/external-embedding/embed-widget-market-quotes.js"
            async
          >
            {
            "width": 750,
            "height": 450,
            "symbolsGroups": [
                {
                "name": "Indices",
                "originalName": "Indices",
                "symbols": [
                    {
                      "name": "FOREXCOM:SPXUSD",
                      "displayName": "S&P 500"
                    },
                    {
                      "name": "FOREXCOM:NSXUSD",
                      "displayName": "Nasdaq 100"
                    },
                    {
                      "name": "FOREXCOM:DJI",
                      "displayName": "Dow 30"
                    },
                    {
                      "name": "INDEX:NKY",
                      "displayName": "Nikkei 225"
                    },
                    {
                      "name": "INDEX:DEU40",
                      "displayName": "DAX Index"
                    }
                ]
                }
            ],
            "showSymbolLogo": true,
            "colorTheme": "light",
            "isTransparent": false,
            "locale": "en"
            }
          </script>
        </div>
      </div>
    </div>
    <div class="md:flex  overflow-x-auto" v-if="view == 'futures'">
      <div>
        <div class="tradingview-widget-container">
          <div class="tradingview-widget-container__widget"></div>
          <script
            type="application/javascript"
            src="https://s3.tradingview.com/external-embedding/embed-widget-market-quotes.js"
            async
          >
            {
            "width": 750,
            "height": 450,
            "symbolsGroups": [
                {
                "name": "Futures",
                "originalName": "Futures",
                "symbols": [
                    {
                      "name": "CME_MINI:ES1!",
                      "displayName": "S&P 500"
                    },
                    {
                      "name": "CME:6E1!",
                      "displayName": "Euro"
                    },
                    {
                      "name": "COMEX:GC1!",
                      "displayName": "Gold"
                    },
                    {
                      "name": "NYMEX:CL1!",
                      "displayName": "Crude Oil"
                    },
                    {
                      "name": "NYMEX:NG1!",
                      "displayName": "Natural Gas"
                    }
                ]
                }
            ],
            "showSymbolLogo": true,
            "colorTheme": "light",
            "isTransparent": false,
            "locale": "en"
            }
          </script>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      view: "forex",
    };
  },
};
</script>